"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const color_1 = require("../utils/color");
const primary = "#9666a2";
const secondary = "#7ac7e2";
const tertiary = "#4cc0ab";
const background = "#26282b";
const darkScheme = {
    colorScheme: "dark",
    primary,
    lightprimary: (0, color_1.mix)(primary, background, 0.7),
    lighterprimary: (0, color_1.mix)(primary, background, 0.9),
    secondary,
    lightsecondary: (0, color_1.mix)(secondary, background, 0.7),
    lightersecondary: (0, color_1.mix)(secondary, background, 0.9),
    tertiary,
    lighttertiary: (0, color_1.mix)(tertiary, background, 0.7),
    lightertertiary: (0, color_1.mix)(tertiary, background, 0.9),
    text: "#e4e4e4",
    background,
    darkgray: "#a8aaae",
    gray: "#626568",
    lightgray: "#414548",
    lightergray: "#313336",
    almostwhite: "#2b2d30",
    success: "#4cd059",
    warning: "#ffdd6a",
    error: "#fe725d",
};
exports.default = darkScheme;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGFyay5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3RoZW1pbmcvc2NoZW1lcy9kYXJrLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsMENBQXFDO0FBRXJDLE1BQU0sT0FBTyxHQUFHLFNBQVMsQ0FBQztBQUMxQixNQUFNLFNBQVMsR0FBRyxTQUFTLENBQUM7QUFDNUIsTUFBTSxRQUFRLEdBQUcsU0FBUyxDQUFDO0FBQzNCLE1BQU0sVUFBVSxHQUFHLFNBQVMsQ0FBQztBQUU3QixNQUFNLFVBQVUsR0FBRztJQUNqQixXQUFXLEVBQUUsTUFBTTtJQUNuQixPQUFPO0lBQ1AsWUFBWSxFQUFFLElBQUEsV0FBRyxFQUFDLE9BQU8sRUFBRSxVQUFVLEVBQUUsR0FBRyxDQUFDO0lBQzNDLGNBQWMsRUFBRSxJQUFBLFdBQUcsRUFBQyxPQUFPLEVBQUUsVUFBVSxFQUFFLEdBQUcsQ0FBQztJQUM3QyxTQUFTO0lBQ1QsY0FBYyxFQUFFLElBQUEsV0FBRyxFQUFDLFNBQVMsRUFBRSxVQUFVLEVBQUUsR0FBRyxDQUFDO0lBQy9DLGdCQUFnQixFQUFFLElBQUEsV0FBRyxFQUFDLFNBQVMsRUFBRSxVQUFVLEVBQUUsR0FBRyxDQUFDO0lBQ2pELFFBQVE7SUFDUixhQUFhLEVBQUUsSUFBQSxXQUFHLEVBQUMsUUFBUSxFQUFFLFVBQVUsRUFBRSxHQUFHLENBQUM7SUFDN0MsZUFBZSxFQUFFLElBQUEsV0FBRyxFQUFDLFFBQVEsRUFBRSxVQUFVLEVBQUUsR0FBRyxDQUFDO0lBQy9DLElBQUksRUFBRSxTQUFTO0lBQ2YsVUFBVTtJQUNWLFFBQVEsRUFBRSxTQUFTO0lBQ25CLElBQUksRUFBRSxTQUFTO0lBQ2YsU0FBUyxFQUFFLFNBQVM7SUFDcEIsV0FBVyxFQUFFLFNBQVM7SUFDdEIsV0FBVyxFQUFFLFNBQVM7SUFDdEIsT0FBTyxFQUFFLFNBQVM7SUFDbEIsT0FBTyxFQUFFLFNBQVM7SUFDbEIsS0FBSyxFQUFFLFNBQVM7Q0FDakIsQ0FBQztBQUVGLGtCQUFlLFVBQVUsQ0FBQyJ9